<div
  class="flex w-full h-full overflow-hidden"
  [cdkTrapFocus]="appTrapFocusS.enabledSgnl()"
>
  <tdv-support-chat
    *ngIf="showIntercomeSgnl()"
    class="right-8 top-16 fixed z-10000"
  ></tdv-support-chat>

  <tdv-app-menu
    *ngIf="showMenuSgnl()"
    [ngClass]="{
      '!fixed !top-0 !bottom-0 !left-0 !z-1000':
        appMenuS.useFixedPostionStyles(),
    }"
    class="bg-sidebar border-r border-body max-w-logo-sidebar min-w-logo-sidebar w-logo-sidebar flex flex-col justify-between align-center h-full py-24 pb-[84px]"
  ></tdv-app-menu>

  <main class="w-full h-full overflow-hidden">
    <router-outlet></router-outlet>
  </main>

  <tdv-global-progress-bar></tdv-global-progress-bar>

  <tdv-upload-resource-wrap class="z-1000"></tdv-upload-resource-wrap>

  <div
    *ngIf="showVersionAvailablePopupSgnl()"
    animate.enter="app-version-available-enter"
    animate.leave="app-version-available-leave"
    class="fixed top-0 right-68 z-1000 h-64 flex items-center"
  >
    <tdv-version-available-popup></tdv-version-available-popup>
  </div>

  <div
    *ngIf="!authUserStateS.authProfileSgnl()"
    class="fixed bottom-10 right-15 text-10 opacity-50 italic"
  >
    {{ appVersion }}
  </div>

  <tdv-logout-overlay
    *ngIf="authUserStateS.showLogoutOverlaySgnl()"
  ></tdv-logout-overlay>
</div>
